import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form' // redux-form reducer 
import { loginReducer } from './login/Reducer'
import { changeState } from './common/reducer'


import { categoryReducer } from './ManageCategory/Reducer'
import { gradeReducer } from './ManageGrade/Reducer'
import { lengthReducer } from './ManageLength/Reducer'
import { sizeReducer } from './ManageSize/Reducer'
import { productReducer } from './ManageProduct/Reducer'
import { dealerReducer } from './ManageDealer/Reducer'
import { brandmenuReducer } from './ManageBrandmenu/Reducer'
import { manufacturerReducer } from './ManageManufacturer/Reducer'
import { customersReducer } from './Customer/Reducer'
import { requirementReducer } from './ManageRequirement/Reducer'
import { commissionReducer } from './Commission/Reducer'
import { ordersReducer } from './ManageOrder/Reducer'
import { warehouseReducer } from './ManageWarehouse/Reducer'
import { pincodeReducer } from './MasterPincode/Reducer'
import { stockReducer } from './WarehouseStock/Reducer'
import { ratesReducer } from './RateUpdates/Reducer'



export const rootReducer = combineReducers({
  form: formReducer,
  changeState: changeState,
  login: loginReducer,
  category: categoryReducer,
  grade: gradeReducer,
  length: lengthReducer,
  size: sizeReducer,
  product: productReducer,
  dealer: dealerReducer,
  brand: brandmenuReducer,
  manufacturer: manufacturerReducer,
  customer: customersReducer,
  requirement: requirementReducer,
  commission: commissionReducer,
  order: ordersReducer,
  warehouse: warehouseReducer,
  pincodes: pincodeReducer,
  stockDetails: stockReducer,
  ratesDetails: ratesReducer
});
